import './Banner.css'

export const Banner = () => {
    return (
        <header className="banner">
            <img src="/imagens/banner.png" alt="Imagem de Banner"></img>
        </header>
    )
}